import type { FC } from 'react';
import { TextInputWithFormField } from 'src/components/form/controlled-input/TextInputWithFormField';

import type { CustomAttributeProps } from './CustomAttributeProps';

export const CustomAttributeNumberInput: FC<
  CustomAttributeProps<number | null>
> = ({ value, onChange, label, disabled, error, description }) => (
  <TextInputWithFormField
    guidance={description}
    testId={label}
    label={label}
    disabled={disabled}
    type={'number'}
    value={value}
    errorMessage={error}
    onChange={(val) =>
      // The server-side value schema is z.number().finite(), so Infinity
      // (e.g. typing 1e999) is cleared rather than rejected on submit
      onChange(typeof val === 'number' && Number.isFinite(val) ? val : null)
    }
  />
);
